export default class birthYearValidator {
    constructor() {
    }

    validate(value) {
        const currentYear = new Date().getFullYear() - 18; // Assuming 18 is the minimum age for validation
        const yearStr = String(value);

        if (!/^\d{4}$/.test(yearStr)) return false;

        return !(value < 1900 || value > currentYear); // Use 1900 as the minimum year
    }
}
